import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AIAssistant from '../ui/AIAssistant';
const PublicLayout = () => {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-536">
      <Header data-id="element-537" />
      <main className="flex-grow" data-id="element-538">
        <Outlet data-id="element-539" />
      </main>
      <Footer data-id="element-540" />
      <AIAssistant data-id="element-541" />
    </div>;
};
export default PublicLayout;